import React from 'react';
import PageHeader from '../common/PageHeader';
import PageFilter from '../common/PageFilter';
import { controlType } from '../../constants/common';
import { employeeConfig, employeeColumns } from '../../constants/MockData';
import { apiBatchRequest } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import GridTable from '../common/Table/Table';
import { Tooltip, IconButton } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
import { applyFilterOnData, IsSectionVisible, UpdateColumnWithConfiguration, useQuery, IsAutoRunPagesEnabled } from '../../utils/helper';
import EmployeeInfo from './EmployeeInfo';
import _ from 'lodash';
import { SECTIONS } from '../../constants/appConstants';
import { NavLink } from 'react-router-dom';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import PageLandingMessage from '../common/PageLandingMessage/PageLandingMessage';

class Employees extends React.PureComponent {
  // Constructor to define initial state.
  constructor(props) {
    super(props);
    this.state = {
      employeeData: [],      
      departmentMasterData: [],
      employeeMasterData: [],
      supervisorMasterData: [],
      propertyMasterData: [],
      marketMasterData: [],
      selectedDepartmentType: '',
      selectedMarketType: '',
      detailView: false,
      selectedEmployeeId: undefined,
      reloadTable: false,
      selectedEmployeeData: [],
      fromMarket: false,
      marketId: 0,
      isApiCall: false,
      isAutoRunEnabled: IsAutoRunPagesEnabled(),
      isSubmitButtonClicked: false
    };
  }

  // ComponentDidMount event used for API calls. It is used to fetch all master data required for filters
  componentDidMount() {    
    const currentPage = window.location.href;
    if (currentPage.includes('market') && currentPage.includes('type')) {
      this.setState({
        fromMarket: true
      });
    }
    const query = useQuery();
    this._asyncRequest = apiBatchRequest([      
      {
        url: API_URL.Employee.GetEmployeeMasterData + '?showInActive=true',
        key: 'employeeMasterData'
      },
      {
        url: API_URL.Employee.GetDepartmentMasterData,
        key: 'departmentMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.Property.GetPropertyMasterData,
        key: 'propertyMasterData'
      },
      {
        url: API_URL.Property.GetPropertyTypeMasterData,
        key: 'propertyTypeMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'marketMasterData',
        fromCache: true,
        duration: 15
      }
    ])
      .then(({ employeeMasterData, departmentMasterData, propertyMasterData, propertyTypeMasterData, marketMasterData }) => {
        this._asyncRequest = null;
        if (employeeMasterData.success !== true) {
          ShowToast(commonLabels.somethingWrong, toastType.ERROR, 5000, 500, 'Server error');
        }
        const market = query.get('market');
        const type = query.get('type');
        const id = query.get('id');
        const selectedData = [];
        if (market && market !== '') {
          selectedData.push({ key: 'marketName', selected: (marketMasterData.data || []).filter((x) => x.marketId === parseInt(market)) });
        }
        if (type && type !== '') {
          if (type.toLowerCase() === 'Employee'.toLowerCase()) {
            selectedData.push({ key: 'departmentName', selected: (departmentMasterData.data || []).filter((x) => x.departmentId === parseInt(id)) });
          } else {
            selectedData.push({
              key: 'propertyTypeName',
              selected: (propertyTypeMasterData.data || []).filter((x) => x.propertyTypeId === parseInt(id))
            });
          }
        }
        this.setState({          
          employeeMasterData: employeeMasterData.data,
          supervisorMasterData: employeeMasterData.data,
          departmentMasterData: departmentMasterData.data,
          propertyMasterData: propertyMasterData.data,
          marketMasterData: marketMasterData.data,
          propertyTypeMasterData: propertyTypeMasterData.data,
          selectedMarketType: market,
          selectedDepartmentType: type,
          defaultSelectedData: _.cloneDeep(selectedData),
          selectedData: selectedData,
          marketId: market
        }, () => {
          if(this.state.isAutoRunEnabled || this.state.isSubmitButtonClicked || this.props.renderAsChild){
            this.getEmployeeData(selectedData);
          }
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  // Event: ComponentWillUnmount
  componentWillUnmount() {
    if (this._asyncRequest) {
      // this._asyncRequest.cancel();
    }
  }

  // Function used to get derived state
  static getDerivedStateFromProps(newProps, state) {
    if ((((newProps || {}).location || {}).navProps || {}).reload !== (state || {}).reload) {      
      return {
        p: '',
        reload: (((newProps || {}).location || {}).navProps || {}).reload,
        detailView: false,
        selectedEmployeeId: undefined
      };
    }
  }

  // Render action columns like View/Edit/Update etc for every record based on conditions
  renderActionColumn = (cellInfo) => {
    return (
      <>
        {IsSectionVisible(SECTIONS.EMPLOYEES, 0, SECTIONS.VIEW)
          ? <Tooltip title="View">
            <IconButton aria-label={'refreshData'} size="small" onClick={() => { this.onRowClick(cellInfo); }}>
              <Visibility fontSize="small" size="small" />
            </IconButton>
          </Tooltip>
          : ''}
      </>
    );
  };

  // Method is used to get Employee records
  getEmployeeData = (selectedData) => {
    let isApiCall = false;
    const showActiveObj = (selectedData.find((m) => m.key === 'showActive') || {});
    isApiCall = Object.keys(showActiveObj).length > 0 ? showActiveObj.selected[0].showActive : false;
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetEmployeeData + '?showInActive=' + isApiCall,
        key: 'employeeData'
      },
    ])
      .then(
        ({
          employeeData
        }) => {
          this._asyncRequest = null;
          if (employeeData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }          
          this.setState({
            employeeData:
              selectedData.length > 0
              ? applyFilterOnData(employeeData.data || [], selectedData)
              : employeeData.data || [],
            responseEmployeeData: employeeData.data || [],
            configuration: employeeData.config,
            selectedData: selectedData || [],
            isSubmitButtonClicked: true
          });          
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  // Method is called when Auto-Run is false. 
  // It resets all the filters when clicked on Reset button and show the message to click on Search button to view data.
  resetPage = (selectedData) => {    
    this.setState({
      responseEmployeeData: null,
      employeeData: [],
      isSubmitButtonClicked: false,
      selectedData
    });
  }

  // Event occures when clicked on Search/Reset buttons. Data is filtered based on selected filters.
  onFilterChange = (selectedData) => {
    let isApiCall = false;
    const isReset = selectedData.length > 0 ? false : true;
    const showActiveObj = (selectedData.find((m) => m.key === 'showActive') || {});
    if (isReset || (showActiveObj !== undefined && showActiveObj.selected !== undefined)) {
      if (isReset || (showActiveObj.selected[0].showActive || this.state.isApiCall)) {
        isApiCall = Object.keys(showActiveObj).length > 0 ? showActiveObj.selected[0].showActive : false;
        this.setState({ selectedData: selectedData }, () => {
          this._asyncRequest = apiBatchRequest([
            {
              url:
                API_URL.Employee.GetEmployeeData +
                '?showInActive=' + isApiCall,
              key: 'employeeData'
            }
          ])
            .then(({ employeeData }) => {
              this._asyncRequest = null;
              if (employeeData.success !== true) {
                ShowToast(
                  commonLabels.somethingWrong,
                  toastType.ERROR,
                  5000,
                  500,
                  'Server error'
                );
              }
              this.setState({
                employeeData: selectedData.length > 0 ? applyFilterOnData(employeeData.data, selectedData) : employeeData.data,
                responseEmployeeData: employeeData.data,
                configuration: employeeData.config,
                selectedData: selectedData,
                reloadTable: !this.state.reloadTable,
                isApiCall,
                isSubmitButtonClicked: true
              }, () => { this.forceUpdate(); });
            })
            .catch(() => {
              this._asyncRequest = null;
            });
        });
      } else {
        const { responseEmployeeData } = this.state;
        const filteredData = applyFilterOnData([...responseEmployeeData], selectedData);
        this.setState({ employeeData: filteredData, selectedData: selectedData, reloadTable: !this.state.reloadTable, isApiCall },
          () => { this.forceUpdate(); });
      }
    } else {
      const { responseEmployeeData } = this.state;
      if(responseEmployeeData === undefined || responseEmployeeData === null || (responseEmployeeData || []).length === 0 ) {
        this.getEmployeeData(selectedData);
      } else {
        const filteredData = applyFilterOnData([...responseEmployeeData], selectedData);
        this.setState({ employeeData: filteredData, selectedData: selectedData, reloadTable: !this.state.reloadTable, isApiCall },
        () => { this.forceUpdate(); });
      }
    }
  };

  // Row click event of Employee record
  onRowClick = (data) => {
    const selectedEmployeeData = [];
    selectedEmployeeData.push(data);    
    const marketId = data.marketId;
    this.setState({ detailView: true, selectedEmployeeId: data.employeeId, selectedEmployeeData, marketId });
  };

  // Click event of Back button, It will navigate to Employee list view from Detail View
  onBackClick = () => {
    this.setState({ detailView: false, selectedEmployeeId: undefined });
  };

  // render function to render the components. It will render Employee Listing as well as Employee Detail view based on conditions
  render() {
    const {
      employeeMasterData,
      supervisorMasterData,
      propertyTypeMasterData,
      propertyMasterData,
      departmentMasterData,
      marketMasterData,
      selectedData,
      detailView,
      configuration,
      selectedEmployeeData,
      fromMarket,
      marketId
    } = this.state;
    return (
      <>
        {detailView
          ? (
            <>
              <EmployeeInfo
                selectedEmployeeId={this.state.selectedEmployeeId}
                onBackClick={this.onBackClick}
                employeeData={selectedEmployeeData}
                marketId={marketId} />
            </>
          )
          : (
            <>
              {fromMarket && (<PageHeader title="Employees"
                actionsConfig={[
                  {
                    icon: (
                      <NavLink
                        to={{
                          pathname: '/markets'                          
                        }}
                        style={{ color: '#FFF', fontSize: 'small' }}>
                        <ArrowBackIcon
                          size="small"
                          className="back-button no-print"
                        />
                      </NavLink>
                    ),                    
                    title: 'Back to Market'
                  }
                ]}></PageHeader>
              )}
              {!fromMarket && (<PageHeader title="Employees"></PageHeader>)}
              <PageFilter
                autoFilter={false}
                filterAlwaysVisible={true}
                onFilterChanged={this.onFilterChange}
                resetPage={(this.state.isAutoRunEnabled || this.props.renderAsChild) ? undefined : this.resetPage}
                filterConfig={[
                  {
                    multiple: true,
                    type: controlType.DropDown,
                    source: marketMasterData,
                    key: 'marketName',
                    placeholder: 'Search Market',
                    title: 'Market'
                  },
                  {
                    multiple: true,
                    type: controlType.DropDown,
                    source: departmentMasterData,
                    key: 'departmentName',
                    placeholder: 'Search Department',
                    title: 'Department',
                    isComaSeprated: true
                  },
                  {
                    multiple: true,
                    type: controlType.DropDown,
                    source: propertyTypeMasterData,
                    key: 'propertyTypeName',
                    placeholder: 'Search Property',
                    title: 'Property Type',
                    isComaSeprated: true
                  },
                  {
                    multiple: true,
                    type: controlType.DropDown,
                    source: propertyMasterData,
                    key: 'propertyName',
                    placeholder: 'Search Property',
                    title: 'Property Name',
                    isComaSeprated: true
                  },
                  {
                    multiple: true,
                    type: controlType.DropDown,
                    source: employeeMasterData,
                    key: 'employeeName',
                    placeholder: 'Search Employee',
                    title: 'Employee',
                    ignoreFilters: ['propertyTypeName', 'propertyName', 'departmentName', 'ultiProEmployeeId']
                  },
                  {
                    multiple: true,
                    type: controlType.DropDown,
                    source: supervisorMasterData,
                    key: 'ultiProEmployeeId',
                    filterOnKey: 'supervisorId',
                    displayValue: 'employeeName',
                    placeholder: 'Search Supervisor',
                    title: 'Supervisor',
                    ignoreFilters: ['propertyTypeName', 'propertyName', 'departmentName', 'employeeName']
                  },
                  {
                    type: controlType.Checkbox,
                    key: 'showActive',
                    placeholder: 'Search Property',
                    title: 'Show Inactive Employees'
                  }
                ]}
                gridColumn={3}
                defaultSelectedData={this.state.defaultSelectedData}
                selectedData={selectedData}
              ></PageFilter>
              {/* If Auto Run is not enabled and buttons not clicked, then show message to click button */}
              {(this.state.isAutoRunEnabled === false && this.state.isSubmitButtonClicked === false) && 
                (this.state.employeeData === null || this.state.employeeData.length <= 0) &&
                this.props.renderAsChild !== true &&
                (
                  <PageLandingMessage buttonName={'SEARCH'}/>
                )
              }
              {(this.props.renderAsChild || this.state.isAutoRunEnabled === true || (this.state.isAutoRunEnabled === false && this.state.isSubmitButtonClicked === true)) &&
                <div className="row table-list-container">
                  <GridTable
                    columns={UpdateColumnWithConfiguration(employeeColumns, configuration)}
                    data={this.state.employeeData}
                    config={employeeConfig}                  
                    renderActionColumn={this.renderActionColumn}
                  ></GridTable>
                </div>
              }
            </>
          )}
      </>
    );
  }
}

export default Employees;
